var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRole4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 15H7.5V11C7.91667 11 8.27083 10.8542 8.5625 10.5625C8.85417 10.2708 9 9.91667 9 9.5V6.5H8V9.5H7.5V6.5H6.5V9.5H6V6.5H5V9.5C5 9.91667 5.14583 10.2708 5.4375 10.5625C5.72917 10.8542 6.08333 11 6.5 11V15ZM10.5 15H11.5V6.5C10.95 6.5 10.4792 6.69583 10.0875 7.0875C9.69583 7.47917 9.5 7.95 9.5 8.5V11.5H10.5V15ZM0.5 18V6L8.5 0L16.5 6V18H0.5ZM2.5 16H14.5V7L8.5 2.5L2.5 7V16Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRole4);
export default __webpack_public_path__ + "static/media/role4.fd6264b86074009a908fc0593d14e163.svg";
export { ForwardRef as ReactComponent };